import { actions } from "../../utils/constants"

export const LeftDataAction = (data) => {
    return { type: actions.LEFT_THERAPY, value: data }
}

export const RightDataAction = (data) => {
    return { type: actions.RIGHT_THERAPY, value: data }
}

export const VolumeLevelsAction = (data) => {
    return { type: actions.VOLUME_LEVELS, value: data }
}